import {combineReducers} from 'redux';
import loginReducer from './LoginReducer';
import settingReducer from './SettingReducer';
import logoutReducer from './LogoutReducer';
import queueReducer from './QueueReducer';
import loadTranReducer from './ReportReducer';
import OneSignal from 'react-onesignal';
import unreceivedTransReducer from "./UnreceivedReducer";

const appReducer = combineReducers({
    loginData : loginReducer,
    settingData : settingReducer,
    logoutData: logoutReducer,
    queueData: queueReducer,
    loadTranData: loadTranReducer,
    unreceivedTransData: unreceivedTransReducer,
})

const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined;
        OneSignal?.deleteTag("orderTag");
    }
    return appReducer(state, action)
}

export default rootReducer;